<template>
<div>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="1200px">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="search()" style="margin-right: 5px;" icon="el-icon-search">查询</el-button>
        <div style="width: 30px;display: inline-block;"></div>
        <div style="float: right">
          <el-select v-model="reduce_type" filterable clearable size="mini" placeholder="减免类型(新)">
            <el-option
              v-for="item in reduce_type_list1"
              :key="item.id" :label="item.name"
              :value="item.id"
              :disabled="item.disabled">
            </el-option>
          </el-select>
          <el-select v-model="discountType" size="mini" placeholder="减免类型(新)" style="width: 150px">
            <el-option
              v-for="item in order_deposit_type_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="deductionType" size="mini" style="width: 150px">
            <el-option :value="1" label="直减" />
            <el-option :value="2" label="折扣" />
          </el-select>
          <el-input-number v-model="deduction" placeholder="" size="mini" :min="0" style="width: 120px"/>
          <el-button size="mini" type="primary" @click="setDeduction()" style="margin-right: 5px;" icon="el-icon-search">批量设置</el-button>
        </div>
      </div>

      <el-descriptions :column="2" border size="mini">
        <el-descriptions-item label="收费对象">
          <el-input size="mini" readonly placeholder="请输入收费对象" style="width: 60%;" v-model="where.h_name_date" clearable></el-input>
          <el-button size="mini" @click="SelectProjectHouse">选择</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <div>
            <el-date-picker
              size="mini"
              v-model="where.start_end_time"
              unlink-panels
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-radio style="margin-left: 20px" v-model="where.is_between_time" label="1">范围</el-radio>
            <el-radio v-model="where.is_between_time" label="0">起始点</el-radio>
          </div>

        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <el-select size="mini" filterable v-model="where.xsc_ChargeItemID_id" placeholder="选择收费项" clearable>
            <el-option
              v-for="item in house_charge_item_list"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" v-model="where.charge_id" placeholder="选择收费标准" clearable>
            <el-option
              v-for="item in house_charge_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="缴款状态">
          <el-radio v-model="where.state" label="1">待付款</el-radio>
          <el-radio v-model="where.state" label="2">已付款</el-radio>
        </el-descriptions-item>
        <el-descriptions-item label="户主姓名">
          <el-input size="mini"  placeholder="请输入户主姓名" style="width: 60%;" v-model="where.customer_name" clearable></el-input>
        </el-descriptions-item>
<!--        <el-descriptions-item label="拆分方式">-->
<!--          默认无-->
<!--        </el-descriptions-item>-->
      </el-descriptions>
    </div>
    <div class="table-wrap">
      <el-table ref="Table" v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange" height="350px">
        <el-table-column
          type="selection"
          width="55" fixed>
        </el-table-column>
        <el-table-column prop="h_name_date" label="房产" align="center" width="320" fixed></el-table-column>
        <el-table-column prop="cust_name" label="收费对象" align="center" width="100"></el-table-column>
        <el-table-column prop="ChargeItemName" label="收费标准" align="center" width="200"></el-table-column>
        <el-table-column label="计费周期" align="center" width="180">
          <template slot-scope="scope">
            {{scope.row.startDate}} ~ {{scope.row.endDate}}
          </template>
        </el-table-column>
        <el-table-column prop="chargePay" label="应收金额" align="center" width="80"></el-table-column>
        <el-table-column prop="discount" label="减免金额" align="center" width="80"></el-table-column>
        <el-table-column prop="account" label="挂账金额" align="center" width="80"></el-table-column>
        <el-table-column prop="PaidChargeSum" label="已缴金额" align="center" width="80"></el-table-column>
        <el-table-column prop="charge" label="实际应收" align="center" width="80"></el-table-column>
        <el-table-column prop="reduce_type" label="减免类型(新)" align="center" width="180">
          <template slot-scope="scope">
            <el-select v-model="scope.row.reduce_type" disabled size="mini" clearable filterable placeholder="未设置">
              <el-option
                v-for="item in reduce_type_list1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="discountType" label="减免类型" align="center" width="130">
          <template slot-scope="scope">
            <el-select v-model="scope.row.discountType" disabled size="mini" clearable filterable placeholder="减免类型">
              <el-option
                v-for="item in order_deposit_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="chargePay" label="本次减免金额" align="center" width="150">
          <template slot-scope="scope">
            <el-input-number @input="discountHandel(scope.row,'discountMoney')" size="mini" placeholder="本次减免金额" v-model="scope.row.discountMoney" clearable style="width: 100%"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="discountAfterMoney" label="减免后金额" align="center" width="80"></el-table-column>
<!--          <template slot-scope="scope">-->
<!--            <el-input disabled @input="discountHandel(scope.row,'discountAfterMoney')" size="mini" placeholder="减免后金额" v-model="scope.row.discountAfterMoney" clearable style="width: 100%"></el-input>-->
<!--          </template>-->

<!--        <el-table-column label="减免结果" align="center" width="80">-->
<!--          <template slot-scope="scope">-->

<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button>
      <el-button @click="submit">确 定</el-button>
    </div>
  </el-dialog>
  <SelectProjectHouse ref="SelectProjectHouse" />
</div>
</template>

<script>
import SelectProjectHouse from "./SelectProjectHouse";
import { Decimal } from 'decimal.js'
export default {
  name: "HouseReductionSelect",
  components: {SelectProjectHouse},
  data(){
    return{
      where:{
        name:"",
        project_house_id:"",
        start_end_time:"",
        xsc_ChargeItemID_id:"",//费项
        charge_id:"",//费项类型
        state:"1",
        is_between_time:"1",
        customer_name: '',
        is_join_customer: 1
      },
      pageData:{
        list:[],
        total:0,
        pageSize:1000,
        page:1
      },
      loading:false,
      multipleSelection:[],
      order_bill_type_list:[],
      house_charge_item_list:[],
      house_charge_list:[],
      reduce_type_list1:[
        {
          id:0,
          name:"未设置"
        },
        {
          id:1,
          name:"合同减免"
        },
        {
          id:2,
          name:"地方政策减免"
        },
        {
          id:3,
          name:"管理减免(有依据)"
        },
        {
          id:4,
          name:"无依据"
        },
        {
          id:5,
          name:"其它减免",
          disabled: true
        }
      ],
      order_deposit_type_list:[],
      dialogVisible:false,
      callback:null,
      deductionType:1,
      deduction:0,
      reduce_type:'',
      discountType:'',
      project_id:"",
    }
  },
  created() {
    this.getHouseChargeItemList()
    this.getOrderDepositTypeList()
  },
  watch:{
    "where.xsc_ChargeItemID_id":function (n) {
      this.getHouseChargeList();
    },
    "dow_form.project_house_id":function (n) {
      this.getHouseChargeList();
    },
  },
  methods:{
    show(config,callback){
      const that = this;
      that.multipleSelection=[]
      that.pageData={
        list:[],
        total:0,
        pageSize:1000,
        page:1
      };
      that.dialogVisible=true;
      that.callback=callback;
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading=true;
      let where=reObject(this.where);
      where.project_house_id=undefined;
      ERP.getRequest({
        url:"admin/ReceivablesSplitMerge/getList",
        data:{
          project_id:that.project_id,
          where:JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      },res=>{
        if(res.code) {
          res.data.list=res.data.list.map(ret=>{

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            ret.discountMoney=0;
            ret.discountAfterMoney=0;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getOrderDepositTypeList() {
      const that = this;
      let where={};
      ERP.getRequest({
        url:"admin/OrderDiscountType/getList",
        data:{
          where:JSON.stringify(where),
          field:"id,name",
          page: 1,
          page_size: 100
        }
      },res=>{
        if(res.code) {
          that.order_deposit_type_list=res.data.list
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    SelectProjectHouse(){
      const that = this;
      that.$refs.SelectProjectHouse.show({},data=>{
        console.log(data)
        that.where.h_name_date=data.tree_str;
        that.where.project_house_id = data.id;
        that.project_id=data.project_id;
        that.$forceUpdate()
      })
    },
    nodeClick(data){
      this.$refs.OrderLog.nodeClick(data);
      this.where.h_name_date=data.tree.map(ret => {
        return ret.name
      }).join('->');
      this.where.project_house_id = data.tree[0].pindex_id;
      this.$forceUpdate()
    },
    getHouseChargeItemList(){//费项类型表
      const that = this;
      let where={};
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){//费项表
      const that = this;
      let where={};
      this.where.project_house_id&&(where.pindex_id=this.where.project_house_id);
      this.where.xsc_ChargeItemID_id&&(where.chargeItem_name_id=this.where.xsc_ChargeItemID_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    discountHandel(item,name){
      // 可减免金额 = 收款金额-已缴金额
      let chargeCanDis = Decimal(item.charge).sub(Decimal(item.PaidChargeSum)).toNumber().toFixed(2)
      if(name==='discountMoney'){
        if(item.discountMoney){
          item.discountAfterMoney = Decimal(chargeCanDis).sub(Decimal(item.discountMoney)).toNumber().toFixed(2);
        }else {
          item.discountAfterMoney=0;
          item.discountMoney=0;
        }
      }else {
        if(item.discountAfterMoney){
          item.discountMoney = Decimal(chargeCanDis).sub(Decimal(item.discountAfterMoney)).toNumber().toFixed(2);
        }else {
          item.discountAfterMoney=0;
          item.discountMoney=0;
        }
      }
      if (item.discountAfterMoney < 0) {
        item.discountAfterMoney=0;
        item.discountMoney=0;
        this.$message.error("房产:" + item['h_name_date'] + ',扣减后金额为负数！');
        return false
      }
    },
    submit(){
      const that = this;
      if(that.multipleSelection.length < 1){
        this.$message.error('没有账单');
        return false;
      }

      let noset = 0;
      let noset1 = 0;
      for (let key in that.multipleSelection) {
        if (that.multipleSelection[key]['reduce_type'] === undefined || that.multipleSelection[key]['reduce_type'] == 0) {
          noset = 1;
          break;
        }
        if (that.multipleSelection[key]['discountType'] === undefined || that.multipleSelection[key]['discountType'] == 0) {
          noset1 = 1;
          break;
        }
      }
      if (noset) {
        this.$message.error("请设置减免类型(新)！");
        return false
      }
      if (noset1) {
        this.$message.error("请设置减免类型！");
        return false
      }

      typeof that.callback==="function"&&that.callback(that.multipleSelection)
      that.dialogVisible=false;
      that.callback=undefined;
    },
    setDeduction() {
      if (this.reduce_type == 0) {
        this.$message.error("请设置减免类型(新)！");
        return false
      }
      if (this.deductionType == 0) {
        this.$message.error("请设置减免类型！");
        return false
      }
      // 折扣
      if (this.deductionType == 2) {
        if (this.deduction > 100) {
          this.$message.error("折扣不能大于100！");
          return false
        }
      }
      if (this.deduction < 0) {
        this.$message.error("扣减值不能小于等于！");
        return false
      }

      for(let key in this.pageData.list) {
        let discountAfterMoney = 0;
        let discountAMoney = 0;
        // let chargePay = this.pageData.list[key]['chargePay'];
        // 可减免金额 = 收款金额-已缴金额
        let chargePay = Decimal(this.pageData.list[key]['charge']).sub(Decimal(this.pageData.list[key]['PaidChargeSum'])).toNumber().toFixed(2)

        // 直接扣减
        if(this.deductionType == 1) {
          console.info(chargePay)
          discountAfterMoney = Decimal(chargePay).sub(Decimal(this.deduction)).toNumber().toFixed(2);
          discountAMoney = this.deduction;
        }
        if (this.deductionType == 2) {
          discountAMoney = Decimal(chargePay).mul(Decimal((Decimal(this.deduction).div(Decimal(100))))).toNumber().toFixed(2);
          discountAfterMoney = Decimal(chargePay).sub(Decimal(discountAMoney)).toNumber().toFixed(2);
        }
        if (discountAfterMoney < 0) {
          this.$message.error("房产:" + this.pageData.list[key]['h_name_date'] + ',扣减后金额为负数！');
          discountAMoney = 0;
          discountAfterMoney = 0;
          return false
        }
        this.pageData.list[key]['discountMoney'] = discountAMoney;
        this.pageData.list[key]['discountAfterMoney'] = discountAfterMoney;
        this.pageData.list[key]['discountType'] = this.discountType;
        this.pageData.list[key]['reduce_type'] = this.reduce_type;
      }
    }
  }
}

function reObject(item){
  return JSON.parse(JSON.stringify(item));
}

function array_unique(arr) {
  let set=new Set();
  arr.map(ret=>{set.add(ret)});
  return Array.from(set);
}

function array_diff(arr1, arr2) {
  return arr1.concat(arr2).filter(function(arg){
    return !(arr1.indexOf(arg) >= 0 && arr2.indexOf(arg) >= 0);
  });
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}


.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  //width: calc( 100vw - 450px );
  //overflow-x: scroll;
  height: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/HouseReductionSelect.vue